import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import Eyebrow from "../../common/Eyebrow";
import RegFont from "../../common/RegFont";
import styles from "./styles.module.scss";
import ScoopImg from "./images/Scoops.svg";
import Button from "../../common/Button";
import { useHistory } from "react-router";
const HowOftenToTake = () => {
    const frequency = useSelector((state) => state.myProfile.originalAnswers.weeklyFreq1);
    const history = useHistory();
    const getProteinIntake = () => {
        if (Number(frequency) <= 2) {
            return {
                text: "2-3x/week",
                count: 2,
            };
        }
        if (Number(frequency) == 4) {
            return {
                text: "4-5x/week",
                count: 4,
            };
        }
        if (Number(frequency) > 4) {
            return {
                text: "7x/week",
                count: 7,
            };
        }
        return {
            text: "",
            count: 0,
        };
    };
    const onClick = () => {
        history.push("/app/subscription#protein");
    };
    return (_jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.how_often, children: [_jsx(Eyebrow, { opacity: 1, children: "How Often To Take" }), _jsxs("div", { className: styles.box, children: [_jsx(RegFont, { fontWeight: 400, children: " Your Recommendation:" }), _jsx(RegFont, { children: getProteinIntake().text }), _jsx("div", { className: styles.scoops, children: Array(getProteinIntake().count)
                                    .fill(0)
                                    .map((_, index) => (_jsx("img", { src: ScoopImg, alt: "" }, index))) }), _jsx(RegFont, { children: "Pro tip: If you think you need more protein in your diet, feel free use 2 scoops or make multiple protein shakes throughout the day. You can easily increase your protein quantity in your subscription page." }), _jsx(Button, { onClick: onClick, color: "green", variant: "primary", children: "Increase Protein Servings" })] })] }), _jsx("div", {})] }));
};
export default HowOftenToTake;
